<template>
    <transition name="fade">
        <div class="upload-image-modal show">
            <div class="modal-backdrop" @click.stop="closeByBackdrop"></div>
            <div
                ref="modalContent"
                class="modal-content relative"
                :class="questionVideo ? 'video-modal' : ''"
                style="transform: translate(-50%, -50%) !important"
                :style="[
                    currentPage == 'externalPage' && !cropTab ? { width: '100%', height: '100%' } : {},
                    questionVideo ? { width: '100%', height: 'auto', 'max-height': 'unset' } : '',
                    cropTab ? { 'min-width': '500px', 'max-height': 'unset' } : ''
                ]"
            >
                <div class="modal-header" :class="{ 'pb-2': true, 'crop-modal': cropTab }">
                    <div class="flex justify-between items-center d-flex justify-content-between align-items-center">
                        <h2
                            v-if="!questionVideo && currentPage == '' && !cropTab"
                            class="m-0 font-size-18 md:font-size-20 shadow-text-none"
                        >
                            {{ translate('upload_modal_header_image', 'Upload Image') }}
                        </h2>
                        <h2
                            v-if="questionVideo && currentPage == ''"
                            class="m-0 font-size-18 md:font-size-20 shadow-text-none"
                        >
                            {{ translate('upload_modal_header_video', 'Upload Video') }}
                        </h2>

                        <i
                            v-if="currentPage != '' || cropTab"
                            @click.stop="back()"
                            class="fa fa-chevron-left shadow-text-none text-grey font-size-18 cursor-pointer"
                        ></i>
                        <i
                            v-if="showCloseButton"
                            @click.stop="closeModal"
                            class="fas text-grey fa-times text-xl shadow-text-none cursor-pointer"
                        ></i>
                    </div>
                </div>
                <div class="modal-body p-0" v-if="currentPage == '' && !cropTab">
                    <div class="upload-menu d-flex flex mx-auto mt-4" v-if="!questionVideo">
                        <label class="upload-in-btn d-flex flex">
                            <i class="fas fa-desktop text-white"></i>
                            <span class="d-flex flex align-items-center items-center">{{
                                translate('upload_modal_button_image_device', 'Upload image from Device')
                            }}</span>
                            <input
                                id="upload-internal"
                                @change="selectImage"
                                accept="image/*"
                                class="hidden"
                                type="file"
                            />
                        </label>
                        <label class="upload-ex-btn d-flex flex" @click="selectExternal">
                            <i class="fas fa-globe text-white"></i>
                            <span class="d-flex flex align-items-center items-center">{{
                                translate('upload_modal_button_image_library', 'Images from clipart library')
                            }}</span>
                        </label>
                        <label v-if="!isStudent" class="upload-ai-btn d-flex flex" @click="selectAi">
                            <i class="fas fa-robot text-white"></i>
                            <span class="d-flex flex align-items-center items-center">{{
                                translate('upload_modal_button_image_ai', 'Generate image from AI')
                            }}</span>
                        </label>
                    </div>
                    <div class="w-full mx-auto upload-menu" v-if="questionVideo">
                        <div class="video-menu mt-4">
                            <label class="upload-video-btn">
                                <i class="fas fa-cloud-upload-alt text-white"></i>
                                <span class="label">{{
                                    translate('upload_modal_button_video_device', 'Upload video from Device')
                                }}</span>
                                <input
                                    type="file"
                                    id="video-input"
                                    @change="getVideo"
                                    accept="video/mp4,video/quicktime"
                                    class="hidden"
                                />
                            </label>
                            <label v-if="showYoutubeUpload" class="upload-video-btn" @click="selectVideoTab">
                                <i class="fab fa-youtube text-white"></i>
                                <span class="label">{{
                                    translate('upload_modal_button_video_youtube', 'Upload video from Youtube')
                                }}</span>
                            </label>
                        </div>
                        <form
                            class="search-image-box mt-4"
                            @submit.prevent="checkExternalVideoPath"
                            v-if="showVideoInput"
                        >
                            <input
                                type="text"
                                class="form-control input"
                                :placeholder="translate('upload_modal_placeholder_youtube_id', 'Insert youtube ID')"
                                v-model="keyword"
                            />
                            <button
                                class="font-opensans btn system-button-color system-button-text-color"
                                type="submit"
                                :disabled="keyword == '' || keyword == lastKeyword"
                                :style="[
                                    keyword == '' || keyword == lastKeyword
                                        ? { cursor: 'default' }
                                        : { cursor: 'pointer' }
                                ]"
                            >
                                {{ translate('upload_modal_button_youtube_search', 'Search') }}
                            </button>
                        </form>
                        <div v-if="videoMeta.video" class="player-box mx-auto mt-3">
                            <div
                                class="border-2 relative rounded border-solid border-black bg-cover bg-center overflow-hidden"
                            >
                                <video-player
                                    id="player"
                                    ref="addPlayer"
                                    :video-meta="videoMeta"
                                    :video-path="videoMeta.video"
                                    :time-duration="videoTimeDuration"
                                    :add-video="true"
                                    class="w-full h-full w-100 h-100"
                                    @maxValue="getMaxValue"
                                    @handleOpenSetTime="openSetTime"
                                ></video-player>
                            </div>
                            <div class="mt-5 mt-10 flex d-flex items-center align-items-center">
                                <video-set-time
                                    v-if="openSlideTime"
                                    class="w-5/6 m-auto w-75"
                                    ref="videoTime"
                                    :min="0"
                                    :max="maxDuration"
                                    @durationUpdate="videoTimeUpdate"
                                ></video-set-time>
                                <!-- <div>
                                <input type="checkbox" class="mute-checkbox" @click="mute = !mute"> Mute
                            </div> -->
                            </div>
                        </div>
                    </div>
                    <div v-if="videoMeta.video" class="d-flex flex w-full justify-between justify-content-between mt-4">
                        <div class="d-flex flex">
                            <div>
                                <div class="col-md-2 custom-control custom-radio" v-if="backend">
                                    <input
                                        class="custom-control-input"
                                        type="radio"
                                        id="mute"
                                        :checked="mute"
                                        @click="mute = !mute"
                                    />
                                    <label for="mute" class="custom-control-label pt-1 font-weight-normal">
                                        <span class="ml-4">{{ translate('upload_modal_button_mute', 'Mute') }}</span>
                                    </label>
                                </div>
                                <div class="input-with-checkbox" style="height: 30px" v-if="!backend">
                                    <div
                                        :class="{ 'input-checkbox': true, 'mute-checkbox': true, checked: mute }"
                                        @click="mute = !mute"
                                    ></div>
                                    <label for="mute" class="mute-text">{{
                                        translate('upload_modal_button_mute', 'Mute')
                                    }}</label>
                                </div>
                            </div>
                            <div>
                                <div class="col-md-2 custom-control custom-radio" v-if="backend">
                                    <input
                                        class="custom-control-input"
                                        type="radio"
                                        id="loop-backend"
                                        :checked="loop"
                                        @click="loop = !loop"
                                    />
                                    <label for="loop-backend" class="custom-control-label pt-1 font-weight-normal">
                                        <span class="ml-4">{{ translate('question_label_loop_video', 'Loop') }}</span>
                                    </label>
                                </div>
                                <div class="input-with-checkbox pl-3" style="height: 30px" v-if="!backend">
                                    <div
                                        id="loop-frontend"
                                        :class="{ 'input-checkbox': true, 'mute-checkbox': true, checked: loop }"
                                        @click="loop = !loop"
                                    ></div>
                                    <label for="loop-frontend" class="mute-text">{{
                                        translate('question_label_loop_video', 'Loop')
                                    }}</label>
                                </div>
                            </div>
                        </div>
                        <div>
                            <button
                                v-if="videoMeta.video"
                                @click="videoMeta.provider != 'youtube' ? addInternalVideo() : addExternalVideo()"
                                class="add-btn system-button-color system-button-text-color"
                                type="button"
                            >
                                {{
                                    videoMeta.flag == 'edit'
                                        ? translate('upload_modal_button_edit', 'Edit')
                                        : translate('upload_modal_button_add', 'Add')
                                }}
                            </button>
                        </div>
                    </div>
                </div>
                <div
                    v-if="!questionVideo && currentPage == 'externalPage' && !cropTab"
                    class="modal-body p-0"
                    ref="refModalBody"
                >
                    <div class="text-center popup-header my-4">
                        <h2 class="m-0 shadow-text-none">
                            {{ translate('upload_modal_header_image_library', 'Images from clipart library') }}
                        </h2>
                    </div>
                    <form class="search-image-box" @submit.prevent="getImageSearch">
                        <input
                            type="text"
                            class="form-control input"
                            :placeholder="translate('upload_modal_placeholder_enter_image', 'Enter image')"
                            v-model="keyword"
                        />
                        <button
                            class="font-opensans btn system-button-color system-button-text-color"
                            type="submit"
                            @click="getImageSearch"
                            :disabled="keyword == '' || keyword == lastKeyword"
                            :style="[
                                keyword == '' || keyword == lastKeyword ? { cursor: 'default' } : { cursor: 'pointer' }
                            ]"
                        >
                            {{ translate('upload_modal_button_image_search', 'Search') }}
                        </button>
                    </form>

                    <div v-if="enableGiphy && showGiphy" class="text-center mt-3">
                        <div class="btn-group">
                            <a
                                @click="isGiphyActive ? selectImageType('image') : null"
                                :class="{ active: !isGiphyActive }"
                            >
                                <span class=""> {{ translate('setting_image', 'Image') }} </span>
                            </a>
                            <a
                                @click="!isGiphyActive ? selectImageType('giphy') : null"
                                :class="{ active: isGiphyActive }"
                            >
                                <div class="giphy-box">
                                    <img
                                        class="giphy-logo"
                                        width="12"
                                        src="../assets/giphy-logo.png"
                                        alt="giphy-logo-png"
                                    />
                                    <span>GIPHY</span>
                                </div>
                            </a>
                        </div>
                    </div>

                    <div v-show="!isGiphyActive" class="grid-scroll">
                        <div class="bg-search">
                            <div id="empty-search">
                                <h2 class="font-size-16 md:font-size-20 my-1 shadow-text-none">
                                    {{ translate('upload_modal_description_search', 'Search something...') }}
                                </h2>
                                <img :src="require(`@/assets/web-search.svg`)" alt="" />
                            </div>
                            <div id="not-found-search">
                                <h2 class="font-size-16 md:font-size-20 my-1 shadow-text-none">
                                    <p>{{ translate('upload_modal_description_not_found', 'Not Found') }}</p>
                                </h2>
                                <img :src="require(`@/assets/not-found.svg`)" alt="" />
                            </div>
                        </div>
                        <div class="bg-loader">
                            <div class="lds-ripple">
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                        <div class="grid">
                            <div class="grid-sizer"></div>
                        </div>
                    </div>

                    <div v-show="isGiphyActive" id="grid-giphy-parent">
                        <div id="grid-giphy"></div>
                        <a id="giphy-logo" href="https://giphy.com" target="_blank">
                            <img src="../assets/giphy-logo.gif" alt="giphy-logo-animate" />
                        </a>
                        <div class="bg-search-giphy">
                            <div id="empty-search-giphy">
                                <h2 class="font-size-16 md:font-size-20 my-1 shadow-text-none">
                                    {{ translate('upload_modal_description_search', 'Search something...') }}
                                </h2>
                                <img :src="require(`@/assets/web-search.svg`)" alt="" />
                            </div>
                            <div id="not-found-search-giphy">
                                <h2 class="font-size-16 md:font-size-20 my-1 shadow-text-none">
                                    <p>{{ translate('upload_modal_description_not_found', 'Not Found') }}</p>
                                </h2>
                                <img :src="require(`@/assets/not-found.svg`)" alt="" />
                            </div>
                        </div>
                        <div class="bg-loader-giphy">
                            <div class="lds-ripple">
                                <div></div>
                                <div></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-body p-0" v-if="cropTab">
                    <div class="text-center popup-header my-4">
                        <h2 class="text-xl md:text-2xl m-0 shadow-text-none">
                            {{ translate('upload_modal_header_crop_image', 'Crop Image') }}
                        </h2>
                    </div>
                    <crop-image
                        v-if="imageCrop"
                        :img-src="imageCrop"
                        :keep-ratio-crop-area="keepRatioCropArea"
                        :img-width="imageCropWidth"
                        :img-height="imageCropHeight"
                        @cropImage="uploadCropImage"
                        ref="cropImage"
                    >
                    </crop-image>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import Masonry from 'masonry-layout'

import { GiphyFetch } from '@giphy/js-fetch-api'
import { renderGrid } from '@giphy/js-components'
import { throttle } from 'throttle-debounce'

let upload, CropImage, VideoPlayer, VideoSetTime

let currentUser = () => {
    return {
        role: ''
    }
}

if (typeof process.env.VUE_APP_IS_BACKEND !== 'undefined') {
    upload = require('../../../backend/src/service/upload.js').default
    CropImage = require('../../../frontend/src/components/CropImage.vue').default
    VideoPlayer = require('../../../frontend/src/components/VideoPlayer.vue').default
    VideoSetTime = require('../../../frontend/src/components/VideoSetTime.vue').default
} else {
    upload = require('@/lib/upload.js').default
    CropImage = require('@/components/CropImage.vue').default
    VideoPlayer = require('@/components/VideoPlayer.vue').default
    VideoSetTime = require('@/components/VideoSetTime.vue').default
    currentUser = require('@/lib/user.js').currentUser
}

export default {
    components: {
        CropImage,
        VideoPlayer,
        VideoSetTime
    },
    data() {
        return {
            showCloseButton: true,
            showAuthPopup: false,
            currentPage: '',
            questionIndex: 0,
            answerIndex: 0,
            btnLocation: '', //question or answer (frontend)
            keyword: '',
            lastKeyword: '',
            videoMeta: {},
            showVideoInput: false,
            maxDuration: 0,
            videoTimeDuration: [],
            cropTab: false,
            imageCrop: '',
            imageCropWidth: 0,
            imageCropHeight: 0,
            backend: false,
            openSlideTime: false,
            mute: false,
            loop: false,
            isGiphyActive: false,
            preventClose: false,
            aiImage: false
        }
    },

    props: {
        questionVideo: {
            type: Boolean,
            default: false
        },

        isLogin: {
            type: Boolean,
            default: true
        },

        isExternalUploadBlocked: {
            type: Boolean,
            default: false
        },

        keepRatioCropArea: {
            type: Boolean,
            default: false
        },

        disableCrop: {
            type: Boolean,
            default: false
        },

        isPaidUser: {
            type: Boolean,
            default: false
        },

        showGiphy: {
            type: Boolean,
            default: true
        },

        showYoutubeUpload: {
            type: Boolean,
            default: true
        },

        videoLimitTime: {
            type: [Number, String],
            default: 15
        }
    },

    computed: {
        ...mapGetters({
            imgSearchList: 'getImageSearch',
            imgSelect: 'getImageServerSelect'
        }),

        enableGiphy() {
            if (this.backend) {
                return process.env.VUE_APP_GIPHY_ENABLE_BACKEND === 'true'
            }

            return process.env.VUE_APP_GIPHY_ENABLE_FRONTEND === 'true'
        },

        isStudent() {
            if (this.backend) {
                return false
            }
            return currentUser().role.includes('student')
        }
    },

    mounted() {
        this.$nextTick(() => {
            this.$refs.modalContent.addEventListener('click', event => {
                if (event.target.className === 'grid-item') {
                    this.selectExternalImage(event)
                }
            })

            if (typeof process.env.VUE_APP_IS_BACKEND !== 'undefined') {
                this.backend = true
            }

            this.$emit('open')
        })
    },

    beforeDestroy() {
        if (this.$refs.modalContent) {
            this.$refs.modalContent.removeEventListener('click', () => {}, false)
        }
    },

    methods: {
        closeModal() {
            if (this.cropTab || this.preventClose) {
                this.confirmToClose(() => {
                    this.$emit('close', this.questionIndex)
                    this.resetForm()
                })
                return
            }

            this.$emit('close', this.questionIndex)
            this.resetForm()
        },

        closeByBackdrop(e) {
            if (!e.target.classList.contains('modal-backdrop')) {
                return
            }

            this.closeModal()
        },

        resetForm() {
            this.currentPage = ''
            this.$store.state.imageSearchList = null
            this.keyword = ''
            this.lastKeyword = ''
            this.videoMeta = {}
            this.showVideoInput = false
            this.cropTab = false
            if (document.querySelector('#video-input')) {
                document.querySelector('#video-input').value = ''
            }
            this.mute = false
            this.loop = false
        },

        selectExternal() {
            if (!this.isPaidUser && !this.backend) {
                this.$emit('not-paid')
                return
            }

            this.resetForm()
            if (!this.isLogin) {
                this.$emit('beforeSelectExternal')
                this.beforeSelectExternal = true
            } else {
                if (this.isExternalUploadBlocked) {
                    return this.$emit('external-upload-blocked')
                }

                this.currentPage = 'externalPage'
                this.aiImage = false
            }
        },

        selectAi() {
            this.resetForm()

            this.aiImage = true

            this.$emit('select-ai')
        },

        selectVideoTab() {
            if (document.querySelector('#video-input')) {
                document.querySelector('#video-input').value = ''
            }
            this.currentPage = ''
            this.keyword = ''
            this.lastKeyword = ''
            this.showVideoInput = true
        },

        selectImage(event) {
            this.aiImage = false

            const file = event.target.files[0]
            const validateFileSuccess = () => {
                const reader = new FileReader()
                reader.onload = async function (e) {
                    this.imageCrop = {
                        img_url: e.target.result,
                        image_original: [file],
                        firstTimeSelect: true
                    }
                    this.$nextTick(() => {
                        if (this.disableCrop) {
                            const bgFile = {
                                target: {
                                    files: [file]
                                }
                            }
                            this.$emit('setImage', bgFile)
                            this.closeModal()

                            return
                        }

                        if (this.btnLocation != 'background') {
                            this.cropTab = true
                        } else {
                            const bgFile = {
                                target: {
                                    files: [file]
                                }
                            }

                            this.$emit('setImage', bgFile)
                            this.closeModal()
                        }
                    })
                }.bind(this)

                reader.readAsDataURL(file)
            }

            const validateFileFail = function () {
                event.target.value = ''
            }

            upload.addFile(file).validate(validateFileSuccess, validateFileFail)
        },

        editImage(imageObject) {
            this.imageCrop = imageObject
            var self = this

            if (typeof imageObject.coordinates == 'undefined') {
                let img = new Image()

                img.onload = function () {
                    imageObject.coordinates = {
                        width: this.width,
                        height: this.height,
                        top: this.height / 2 - (this.height / 2 - 252),
                        left: this.width / 2 - (this.width / 2 - 252)
                    }

                    self.cropTab = true
                    self.$nextTick(() => {
                        self.$refs.cropImage.setStencilPosition(imageObject.coordinates)
                    })
                }

                img.src = imageObject.image_original
            } else {
                this.cropTab = true
                this.$nextTick(() => {
                    this.$refs.cropImage.setStencilPosition(imageObject.coordinates)
                })
            }
        },

        async getImageSearch() {
            let bgSearch = document.querySelector('.bg-search')
            let notFoundSearch = document.querySelector('#not-found-search')
            let bgLoader = document.querySelector('.bg-loader')
            let gridScroll = document.querySelector('.grid-scroll')
            let emptySearch = document.querySelector('#empty-search')

            if (this.showGiphy) {
                this.removeGrid()
                this.renderGifGrid()
            }

            this.clearMasonry()

            gridScroll.style.overflowY = 'hidden'
            bgSearch.style.visibility = 'hidden'

            setTimeout(() => {
                emptySearch.style.display = 'none'
                bgSearch.style.display = 'none'
            }, 500)

            bgLoader.classList.add('active')
            this.lastKeyword = this.keyword
            this.$store.state.imageSearchList = null

            await this.$store.dispatch('fetchImageSearch', this.keyword)

            if (this.imgSearchList.length > 0) {
                for (let i of this.imgSearchList) {
                    await this.createMasonryElement(i)
                }
            } else {
                notFoundSearch.style.display = 'block'
                bgSearch.style.display = 'flex'
                bgSearch.style.visibility = 'visible'
            }

            let grid = document.querySelector('.grid')

            if (!grid) return

            setTimeout(() => {
                gridScroll.style.overflowY = 'auto'
                gridScroll.style.overflowX = 'hidden'
                this.setMasonry()
                bgLoader.classList.remove('active')
            }, 500)
        },

        setMasonry() {
            let grid = document.querySelector('.grid')
            let msnry = new Masonry(grid, {
                itemSelector: '.grid-item',
                columnWidth: '.grid-sizer',
                transitionDuration: '0.8s',
                gutter: 4,
                stagger: 20
            })
            msnry.layout()
        },

        createPlaceholderImage(width, height) {
            const canvas = document.createElement('canvas')
            canvas.width = width
            canvas.height = height

            const context = canvas.getContext('2d')

            context.fillStyle = '#f0f0f0'
            context.fillRect(0, 0, canvas.width, canvas.height)

            const base64 = canvas.toDataURL()

            canvas.remove()

            return base64
        },

        async createMasonryElement(data) {
            let d = await data
            let grid = document.querySelector('.grid')

            if (!grid) return

            let msnry = new Masonry(grid, {
                itemSelector: '.grid-item',
                columnWidth: '.grid-sizer',
                transitionDuration: '0.8s',
                gutter: 4,
                stagger: 20
            })
            let div = document.createElement('div')
            let img = document.createElement('img')
            let span = document.createElement('span')
            div.style.position = 'relative'
            span.innerHTML = `${data.width}x${data.height}`

            const lessWidth = data.width / 100
            const lessHeight = data.height / 100
            img.src = this.createPlaceholderImage(lessWidth, lessHeight)

            const imageLoad = new Image()
            imageLoad.src = data.thumbnail
            imageLoad.onload = function () {
                img.src = data.thumbnail
            }

            div.className = 'grid-item'
            div.setAttribute('data-img', d.img_url)
            div.setAttribute('data-source', d.source)
            div.setAttribute('data-thumbnail', d.thumbnail)
            div.appendChild(img)
            div.appendChild(span)
            grid.appendChild(div)
            msnry.appended(div)
        },

        clearMasonry() {
            let grid = document.querySelector('.grid')
            let gridSizer = document.createElement('div')
            grid.style.height = 'auto'
            grid.innerHTML = ''
            gridSizer.className = 'grid-sizer'
            grid.appendChild(gridSizer)
        },

        async selectExternalImage(event) {
            let img_url = event.target.getAttribute('data-img')
            let source = event.target.getAttribute('data-source')
            let thumbnail = event.target.getAttribute('data-thumbnail')
            let bgLoader = document.querySelector('.bg-loader')
            // let gridScroll = document.querySelector(".grid-scroll")

            if (!bgLoader) {
                bgLoader = document.createElement('div')
                bgLoader.className = 'bg-loader'
            }

            let param = {
                img_url: img_url || thumbnail,
                source: source,
                thumbnail: thumbnail
            }

            try {
                this.preventClose = true
                //gridScroll.style.overflowY = "hidden"
                bgLoader.classList.add('select-active')
                const imageParam = await this.$store.dispatch('fetchServerImage', param)
                this.imageCrop = this.imgSelect
                this.imageCrop.image_original = this.imageCrop.img_url
                this.imageCrop.firstTimeSelect = true
                this.$nextTick(async () => {
                    if (this.disableCrop) {
                        const file = await this.getImageWithoutCrop(imageParam)
                        this.$emit('setImage', file)
                        this.closeModal()
                    } else if (this.btnLocation != 'background') {
                        this.cropTab = true
                        this.$emit('close-ai')
                    } else {
                        const bgFile = {
                            target: {
                                files: [
                                    {
                                        img_url: imageParam.img_url,
                                        source: imageParam.source,
                                        thumbnail: imageParam.thumbnail,
                                        external: true
                                    }
                                ]
                            }
                        }
                        this.$emit('setImage', bgFile)
                        this.closeModal()
                    }
                })
            } catch (e) {
                if (typeof process.env.VUE_APP_IS_BACKEND !== 'undefined') {
                    let message = 'An error occurred'

                    if (e.response && e.response.status == 422 && e.response.data.message === 'source_is_not_image') {
                        message =
                            "The source of the image that you've selected might not be an image, please select another one."
                    }

                    window.shout.error(message)
                } else {
                    let key = 'upload_modal_alert_error'

                    if (e.response && e.response.status == 422 && e.response.data.message === 'source_is_not_image') {
                        key = 'upload_model_source_is_not_image'
                    }

                    this.toastError(this.translate(key))
                }

                // gridScroll.style.overflowY = "auto"
                bgLoader.classList.remove('select-active')
                this.currentPage = ''

                return
            } finally {
                this.preventClose = false
            }

            // if (this.btnLocation != "answer") {
            //     this.$emit('setImage', event, this.questionIndex, this.answerIndex)
            // } else {
            //     this.$emit('setAnswerImage', event, this.questionIndex, this.answerIndex)
            // }

            // this.closeModal()
        },

        uploadCropImage(file) {
            this.cropTab = false

            if (file.target.files[0].preventCrop) {
                this.closeModal()
                return
            }

            if (this.btnLocation != 'answer') {
                this.$emit('setImage', file, this.questionIndex, this.answerIndex, this.aiImage)
            } else {
                this.$emit('setAnswerImage', file, this.questionIndex, this.answerIndex)
            }
            this.closeModal()
        },

        getVideo(event) {
            let v = this
            v.videoMeta = {}
            v.videoTimeDuration = []
            v.mute = false
            v.loop = false
            let file = event.target.files[0]
            const validateFileSuccess = () => {
                let videoElement = document.createElement('video')
                let fileURL = URL.createObjectURL(file)
                videoElement.src = fileURL
                videoElement.ondurationchange = async function () {
                    let videoDuration = this.duration

                    if (videoDuration <= v.videoLimitTime) {
                        //check video duration <= duration limit
                        let videoThumbnail = await v.getVideoThumbnail(file)
                        let reader = new FileReader()
                        let imagePath
                        reader.readAsDataURL(videoThumbnail.target.files[0])
                        reader.onload = function (e) {
                            imagePath = e.target.result
                            v.$nextTick(() => {
                                v.videoMeta = {
                                    video: videoElement.src,
                                    img_url: imagePath,
                                    provider: 'mp4',
                                    videoEvent: file,
                                    thumbnailObject: videoThumbnail
                                }
                                v.showVideoInput = false
                            })
                        }.bind(this)
                    } else {
                        event.target.value = ''
                        v.popup().alert('File duration too much')
                        return false
                    }
                }
            }

            const validateFileFail = function () {
                event.target.value = ''
            }

            upload.addFile(file).validateVideo(validateFileSuccess, validateFileFail)
        },

        async getVideoThumbnail(myFile) {
            let videoElement = document.createElement('video')
            let fileURL = URL.createObjectURL(myFile)
            let canvas = document.createElement('canvas')
            let ctx = canvas.getContext('2d')
            videoElement.src = fileURL
            await new Promise(resolve => {
                videoElement.addEventListener('loadedmetadata', () => {
                    videoElement.width = videoElement.videoWidth
                    videoElement.height = videoElement.videoHeight
                    canvas.width = videoElement.width
                    canvas.height = videoElement.height
                    // Seek the video to 25%
                    videoElement.currentTime = 0
                    videoElement.addEventListener('timeupdate', function () {
                        ctx.drawImage(videoElement, 0, 0, videoElement.width, videoElement.height)
                    })
                })
                videoElement.addEventListener('seeked', () => resolve())
            })

            return new Promise(resolve => {
                const canvasUrl = canvas.toDataURL()
                let custom
                fetch(canvasUrl)
                    .then(res => res.blob())
                    .then(blob => {
                        const file = new File([blob], 'image.jpeg', { type: 'image/jpeg' })
                        custom = {
                            target: {
                                files: [file]
                            }
                        }

                        resolve(custom)
                    })
            })
        },

        async checkExternalVideoPath() {
            this.videoMeta = {}
            this.videoTimeDuration = []
            this.lastKeyword = this.keyword
            let url

            if (this.keyword.includes('youtube')) {
                url = new URL(this.keyword)
            } else {
                let keyword = this.keyword

                if (keyword.includes('youtu.be')) {
                    const match = keyword.match(/youtu\.be\/([a-zA-Z0-9_-]+)/)

                    if (match && match[1]) {
                        keyword = match[1]
                    }
                }

                url = new URL(
                    `https://www.youtube.com/watch?v=${keyword}&modestbranding=1&autohide=1&showinfo=0&controls=0`
                )
            }

            let videoUrl = url.searchParams.get('v')
            let baseUrl =
                typeof process.env.VUE_APP_ROOT_URL == 'undefined'
                    ? process.env.VUE_APP_API_BASE_URL
                    : process.env.VUE_APP_ROOT_URL
            baseUrl = baseUrl.replace('/admin/api', '/')
            let getImage = await fetch(`${baseUrl}yt/${videoUrl}`)
            if (getImage.status === 200) {
                this.videoMeta = {
                    video: videoUrl,
                    img_url: `${baseUrl}yt/${videoUrl}`,
                    provider: 'youtube'
                }
            } else {
                this.popup().alert(this.translate('upload_modal_alert_wrong_path', 'Wrong path'))
            }
        },

        async addInternalVideo() {
            this.$refs.addPlayer.endVideo()

            if (this.videoTimeDuration && this.videoTimeDuration.length < 1) {
                this.videoTimeDuration = [0, this.maxDuration]
            }

            if (this.videoMeta.flag && this.videoMeta.flag == 'edit') {
                let videoTimeDuration = this.videoTimeDuration
                let videoMute = this.mute
                let videoLoop = this.loop
                let questionIndex = this.questionIndex
                if (typeof process.env.VUE_APP_IS_BACKEND != 'undefined') {
                    this.$emit('setVideoTime', videoTimeDuration)
                    this.$emit('setVideoMute', videoMute)
                    this.$emit('setVideoLoop', videoLoop)
                } else {
                    this.$store.commit('updateVideoTime', { questionIndex, videoTimeDuration })
                    this.$store.commit('updateVideoMute', { questionIndex, videoMute })
                    this.$store.commit('setLoopVideo', { videoLoop, questionIndex })
                }
            } else {
                await this.$emit(
                    'setVideo',
                    this.videoMeta.videoEvent,
                    this.videoTimeDuration,
                    this.mute,
                    this.loop,
                    this.videoMeta.provider,
                    this.questionIndex,
                    this.answerIndex
                )
                await this.$emit('setImage', this.videoMeta.thumbnailObject, this.questionIndex, this.answerIndex)
            }
            this.closeModal()
        },

        addExternalVideo() {
            this.$refs.addPlayer.endVideo()
            let videoObject = {
                target: {
                    files: [
                        {
                            video: this.videoMeta.video,
                            img_url: this.videoMeta.img_url,
                            external: true,
                            mute: this.mute,
                            loop: this.loop
                        }
                    ]
                }
            }

            if (this.videoTimeDuration.length < 1) {
                this.videoTimeDuration = [0, this.maxDuration]
            }

            if (this.videoMeta.flag && this.videoMeta.flag == 'edit') {
                let videoTimeDuration = this.videoTimeDuration
                let videoMute = this.mute
                let videoLoop = this.loop
                let questionIndex = this.questionIndex
                if (typeof process.env.VUE_APP_IS_BACKEND != 'undefined') {
                    this.$emit('setVideoTime', videoTimeDuration)
                    this.$emit('setVideoMute', videoMute)
                    this.$emit('setVideoLoop', videoLoop)
                } else {
                    this.$store.commit('updateVideoTime', { questionIndex, videoTimeDuration })
                    this.$store.commit('updateVideoMute', { questionIndex, videoMute })
                    this.$store.commit('setLoopVideo', { videoLoop, questionIndex })
                }
            } else {
                this.$emit(
                    'setVideo',
                    videoObject,
                    this.videoTimeDuration,
                    this.mute,
                    this.loop,
                    this.videoMeta.provider,
                    this.questionIndex,
                    this.answerIndex
                )
                this.$emit('setImage', videoObject, this.questionIndex, this.answerIndex)
            }
            this.closeModal()
        },

        getMaxValue(duration) {
            this.maxDuration = parseInt(duration)
        },

        openSetTime(flag) {
            this.openSlideTime = true
            this.$nextTick(() => {
                if (flag == 'edit') {
                    // if edit video
                    this.$refs.videoTime.changeTimeValue(this.videoTimeDuration)
                }
            })
        },

        videoTimeUpdate(timeUpdate) {
            this.videoTimeDuration = timeUpdate
        },

        editVideo(question) {
            this.videoMeta = {
                video: question.video,
                img_url: question.image,
                provider: question.video_provider,
                duration: question.video_time,
                flag: 'edit'
            }
            this.videoTimeDuration = question.video_time
            this.mute = question.video_mute
            this.loop = question.video_loop
        },

        setQuestionIndex(value) {
            this.questionIndex = value
        },

        setAnswerIndex(value) {
            this.answerIndex = value
        },

        setLocation(value) {
            this.btnLocation = value
        },

        popup() {
            let popup

            try {
                popup = require('@/lib/popup.js').default
            } catch {
                if (typeof window.shout != 'undefined') {
                    popup = window.shout
                    popup.alert = popup.error
                }
            }

            return popup
        },

        translate(key, msg) {
            if (typeof process.env.VUE_APP_IS_BACKEND !== 'undefined') {
                return msg
            }

            return this.$t(key)
        },

        async getImageWithoutCrop(data) {
            const image = data.img_url
            const imageOriginal = data.image_original
            const imageSource = data.source

            const response = await fetch(image)
            const blob = await response.blob()
            const file = new File([blob], 'image.jpeg', { type: blob.type })
            file.source = imageSource
            file.image_original = imageOriginal

            const bgFile = {
                target: {
                    files: [file]
                }
            }

            return bgFile
        },

        async getImageGif(data) {
            const imageOriginal = data.image_original
            const imageSource = data.source

            const response = await fetch(imageOriginal)
            const blob = await response.blob()
            const file = new File([blob], 'image.gif', { type: blob.type })

            // Hack create 1x1 pixel image
            const pixel = new Uint8Array([0, 0, 0, 0])
            const pixelBlob = new Blob([pixel], { type: 'image/gif' })
            const pixelFile = new File([pixelBlob], 'image.gif', { type: blob.type })

            file.source = imageSource
            file.image_original = imageOriginal
            file.ignore_validate = true

            const gifFile = {
                target: {
                    files: [file, pixelFile]
                }
            }

            return gifFile
        },

        selectImageType(type) {
            this.isGiphyActive = type === 'giphy'

            if (this.keyword != '') {
                this.getImageSearch()
            }
        },

        async renderGifGrid() {
            let bgLoaderGiphy = document.querySelector('.bg-loader-giphy')
            let giphyLogo = document.querySelector('#giphy-logo')
            bgLoaderGiphy.classList.add('active')

            const gridTarget = document.querySelector('#grid-giphy')
            const modalBody = this.$refs.refModalBody

            //giphy api key
            const gf = new GiphyFetch(process.env.VUE_APP_GIPHY_API_KEY)

            const { data: gifs } = await gf.search(this.keyword, { limit: 10 })

            this.setBgSearchGiphy(gifs)

            const render = () => {
                return renderGrid(
                    {
                        width: modalBody.offsetWidth,
                        columns: modalBody.offsetWidth < 500 ? 2 : 3,
                        fetchGifs: offset => gf.search(this.keyword, { offset, limit: 10 }),
                        onGifClick: async (gif, event) => {
                            event.preventDefault()
                            bgLoaderGiphy.classList.add('select-active')

                            const param = {
                                image_original: gif.images.fixed_height.url,
                                source: gif.source
                            }

                            const file = await this.getImageGif(param)

                            bgLoaderGiphy.classList.remove('select-active')
                            this.$emit('setImage', file, this.questionIndex, this.answerIndex)
                            this.closeModal()
                        }
                    },
                    gridTarget
                )
            }

            const resizeRender = throttle(500, render)
            window.addEventListener('resize', resizeRender, false)
            giphyLogo.style.opacity = 1
            render()
            bgLoaderGiphy.classList.remove('active')
        },

        removeGrid() {
            const grid = document.querySelector('#grid-giphy')
            grid.remove()

            const gridParent = document.querySelector('#grid-giphy-parent')
            const gridChild = document.createElement('div')
            gridChild.id = 'grid-giphy'
            gridParent.appendChild(gridChild)
        },

        setBgSearchGiphy(gifs) {
            const bgSearchGiphy = document.querySelector('.bg-search-giphy')
            const emptySearchGiphy = document.querySelector('#empty-search-giphy')
            const notFoundSearchGiphy = document.querySelector('#not-found-search-giphy')

            if (gifs.length > 0) {
                bgSearchGiphy.style.display = 'none'
                notFoundSearchGiphy.style.display = 'none'
            } else {
                bgSearchGiphy.style.display = 'block'
                emptySearchGiphy.style.display = 'none'
                notFoundSearchGiphy.style.display = 'block'
            }
        },

        back() {
            if (this.cropTab || this.preventClose) {
                this.confirmToClose(() => {
                    this.currentPage = ''
                    this.cropTab = false
                })

                return
            }

            this.currentPage = ''
            this.cropTab = false
        },

        confirmToClose(acceptCallback) {
            const msg = this.translate(
                'setting_confirm_close',
                'Are you certain you want to close? Any unsaved changes will be lost'
            )

            if (typeof process.env.VUE_APP_IS_BACKEND !== 'undefined') {
                this.$vueConfirm.confirm(
                    {
                        message: msg,
                        button: {
                            no: 'No',
                            yes: 'Yes'
                        }
                    },
                    function (confirm) {
                        if (confirm) {
                            if (acceptCallback) {
                                acceptCallback()
                            }
                        }
                    }
                )
            } else {
                this.popup().confirm(msg, () => {
                    if (acceptCallback) {
                        acceptCallback()
                    }
                })
            }
        }
    }
}
</script>

<style lang="scss">
:root {
    --dark-color: #383838;
    --light-color: #fff;
    --select-light-color: rgba(255, 255, 255, 0.7);
}

@import '@/scss/variable.scss';

.upload-image-modal {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;

    &.fade-enter-active,
    &.fade-leave-active {
        transition: opacity 0.3s;
    }

    &.fade-enter,
    &.fade-leave-to {
        opacity: 0;
    }

    .modal-header {
        display: block;
        border: none;
        position: relative;
        border-bottom: none !important;

        &.crop-modal {
            margin-bottom: 0 !important;
        }

        i {
            color: var(--dark-color);
            font-size: 20px !important;
        }

        h2 {
            font-size: 20px;

            @media screen and (max-width: 767px) {
                font-size: 18px;
            }
        }
    }

    .popup-header {
        h2 {
            font-size: 20px !important;

            @media screen and (max-width: 767px) {
                font-size: 18px !important;
            }
        }
    }

    .modal-backdrop {
        position: unset !important;
        background-color: rgba(0, 0, 0, 0.5);
        width: 100%;
        height: 100%;
        min-height: 100vh;
        display: flex;
        justify-content: center;
        align-items: start;
    }

    .modal-content {
        background-color: var(--light-color);
        padding: 1rem;
        min-width: 560px;
        max-width: 750px;
        width: auto;
        max-height: 600px;
        height: auto;
        overflow: hidden;
        border-radius: 4px;
        box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.6);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) !important;
        display: flex;
        flex-direction: column;
        z-index: 1042;

        @media screen and (max-width: 575px) {
            max-width: 92%;
            max-height: 92%;
            width: 100%;
            height: auto;
            margin: auto;
            min-width: unset !important;
        }

        &.video-modal {
            @media screen and (max-width: 767px) {
                width: 92% !important;
                max-height: 92% !important;
                height: auto;
                margin: auto;
                min-width: 0;
                max-height: unset;
            }
        }

        .modal-body {
            display: flex;
            flex-direction: column;
            height: 100%;
            overflow: hidden;

            .my-4 {
                margin: 1rem 0 !important;
            }

            .mt-4 {
                margin-top: 1rem !important;
            }

            .search-image-box {
                display: inline-flex;
                align-items: center;
                column-gap: 16px;
                width: 100%;

                @media screen and (max-width: 767px) {
                    // flex-direction: column;
                    row-gap: 8px;
                }

                input,
                button {
                    font-size: 16px;

                    @media screen and (max-width: 767px) {
                        font-size: 14px;
                    }
                }
            }

            .video-menu {
                column-gap: 8px;
                display: flex;

                @media screen and (max-width: 767px) {
                    display: flex;

                    .upload-video-btn {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                    .label {
                        display: none;
                    }
                }

                label {
                    padding: 0.5rem !important;
                    flex-direction: row !important;
                }

                i {
                    font-size: 20px !important;
                }

                span {
                    text-align: left !important;
                }
            }

            .upload-menu {
                width: 100%;
                gap: 0.5rem;
                overflow: unset !important;

                @media screen and (max-width: 767px) {
                    flex-direction: column;
                }

                label {
                    flex: 1;
                    flex-direction: column;
                    row-gap: 1rem;
                    width: 100%;
                    padding: 1rem 0.5rem;
                    border-radius: 4px;
                    display: inline-flex;
                    justify-content: flex-start;
                    align-items: center;
                    column-gap: 16px;
                    cursor: pointer;
                    transition: transform 0.5s;

                    @media screen and (max-width: 767px) {
                        row-gap: 0.5rem;
                    }

                    &.upload-in-btn {
                        background-color: #28a745;

                        &:hover {
                            transform: scale(1.025);
                        }
                    }

                    &.upload-ex-btn {
                        background-color: #56d1fa;

                        &:hover {
                            transform: scale(1.025);
                        }
                    }

                    &.upload-ai-btn {
                        background-color: #007bff;

                        &:hover {
                            transform: scale(1.025);
                        }
                    }

                    &.upload-video-btn {
                        background-color: #ff3200;
                    }

                    &.upload-video-internal-btn {
                        background-color: #ff3200;
                    }

                    &.mute-text {
                        padding: 0;
                        margin: 0;
                    }

                    i,
                    span {
                        text-align: center;
                        text-shadow: none;
                        color: #fff;
                    }

                    i {
                        font-size: 2rem;

                        @media screen and (max-width: 767px) {
                            font-size: 1.5rem;
                        }
                    }

                    span {
                        flex: 1;
                        font-size: 16px;

                        @media screen and (max-width: 767px) {
                            font-size: 14px;
                        }
                    }
                }
            }

            .player-box {
                width: 100%;
                height: 100%;
                max-width: 640px;

                .border-black {
                    border: 2px solid #22292f;
                }

                .rounded {
                    border-radius: 0.75rem !important;
                }

                > div:first-of-type {
                    aspect-ratio: 16 / 9;
                }
            }

            iframe {
                width: 100%;
                height: 100%;
            }

            button:not(.plyr__control) {
                padding: 0 16px;
                height: 42px;
                border-radius: 4px;
                border: none;
                cursor: pointer;
                background-color: #000;
                color: #fff;
                transition: 0.5s;

                @media screen and (max-width: 767px) {
                    height: 41px;
                }

                &:hover:not(:disabled) {
                    background-color: #2a2727;
                }

                &:disabled {
                    background-color: #cccccc;
                    color: #666666;
                }

                &.add-btn {
                    width: 70px;
                    height: 40px;
                    align-self: center;
                    display: block;
                    // margin: 32px auto 0 auto;

                    @media screen and (max-width: 767px) {
                        width: 100%;
                        // margin: auto;
                    }
                }
            }

            input.form-control {
                display: block;
                width: 100%;
                height: calc(2.5rem + 2px);
                padding: 0.375rem 0.75rem;
                line-height: 1.5;
                color: $input-placeholder-color;
                background-color: var(--light-color);
                background-clip: padding-box;
                border: 1px solid #ced4da;
                border-radius: 4px;
                -webkit-box-shadow: inset 0 0 0 rgb(0, 0, 0);
                box-shadow: inset 0 0 0 rgb(0, 0, 0);
                -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
                transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
                transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
                transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
                    -webkit-box-shadow 0.15s ease-in-out;
                -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);

                &::placeholder {
                    text-transform: none;
                    text-align: left;
                }
            }

            .input-with-checkbox {
                display: flex;
                align-items: center;
                column-gap: 8px;

                .mute-checkbox {
                    position: relative;
                    top: 0;
                    left: 0;
                    transform: translateY(0);
                }
            }

            .custom-control {
                min-height: 0;
            }

            .custom-control-input:checked ~ .custom-control-label::before {
                border-color: #dc3545;
                background-color: #dc3545 !important;
            }
            .custom-control-label {
                cursor: pointer;
                margin-bottom: 0 !important;
                &::before,
                &::after {
                    width: 1.5rem;
                    height: 1.5rem;
                }
            }
            .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
                background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg aria-hidden='true' focusable='false' data-prefix='fas' data-icon='check' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' class='svg-inline--fa fa-check fa-w-16 fa-3x'%3e%3cpath fill='%23fff' d='M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z' class=''%3e%3c/path%3e%3c/svg%3e");
            }

            .grid-scroll {
                overflow-y: auto;
                height: 100%;
                margin-top: 16px;
                position: relative;

                .bg-search {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 100%;
                    height: 100%;
                    padding: 16px;
                    background-color: rgba(220, 53, 69, 0.1);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    transition: visibility 0.5s;

                    h2 {
                        display: block;
                        width: 100%;
                        margin-bottom: 24px !important;
                        text-align: center;
                        font-size: 24px;
                        word-break: break-word;
                        z-index: 1;

                        @media screen and (max-width: 767px) {
                            font-size: 16px;
                        }
                    }

                    img {
                        max-width: 300px;
                        width: 100%;
                        height: auto;
                        display: block;
                        margin: auto;
                    }

                    #not-found-search {
                        display: none;
                    }
                }

                .image-loader {
                    border: 8px solid #c7c7c7;
                    /* Light grey */
                    border-top: 8px solid var(--dark-color);
                    /* Blue */
                    border-radius: 50%;
                    width: 80px;
                    height: 80px;
                    animation: spin 2s linear infinite;
                }

                @keyframes spin {
                    0% {
                        transform: rotate(0deg);
                    }

                    100% {
                        transform: rotate(360deg);
                    }
                }

                .grid {
                    width: 100%;
                    height: 100% !important;

                    &:after {
                        content: '';
                        display: block;
                        clear: both;
                    }

                    .grid-sizer,
                    .grid-item {
                        width: 32.8%;

                        @media screen and (max-width: 767px) {
                            width: 49%;
                        }
                    }

                    .grid-item {
                        float: left;
                        margin-bottom: 4px;
                        border-radius: 4px;
                        overflow: hidden;
                        transition: opacity 0.5s, transform 0.5s;
                        cursor: pointer;

                        &:hover {
                            transform: scale(1.02);
                        }

                        img {
                            display: block;
                            width: 100%;
                            height: 100%;
                            pointer-events: none;
                        }

                        span {
                            position: absolute;
                            bottom: 0;
                            right: 0;
                            padding: 2px;
                            font-size: 12px;
                            background-color: rgba(0, 0, 0, 0.7);
                            color: #fff;
                        }
                    }
                }
            }

            .bg-loader,
            .bg-loader-giphy {
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                background-color: var(--light-color);
                display: flex;
                justify-content: center;
                align-items: center;
                opacity: 0;
                transition: opacity 0.5s;
                pointer-events: none;
                z-index: 1;

                &.active {
                    opacity: 1;
                    position: sticky;
                }

                &.select-active {
                    background-color: var(--select-light-color);
                    opacity: 1;
                    position: fixed;
                    pointer-events: unset;
                }

                .lds-ripple {
                    display: inline-block;
                    position: relative;
                    width: 80px;
                    height: 80px;
                }

                .lds-ripple div {
                    position: absolute;
                    border: 4px solid;
                    opacity: 1;
                    border-radius: 50%;
                    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
                    color: #ef0000;
                }

                .lds-ripple div:nth-child(2) {
                    animation-delay: -0.5s;
                    color: #ef0000;
                }

                @keyframes lds-ripple {
                    0% {
                        top: 36px;
                        left: 36px;
                        width: 0;
                        height: 0;
                        opacity: 1;
                    }

                    100% {
                        top: 0px;
                        left: 0px;
                        width: 72px;
                        height: 72px;
                        opacity: 0;
                    }
                }
            }

            .btn-group {
                width: 100%;
                border-radius: 4px;
                overflow: hidden;
                display: inline-flex;
                border: 2px solid var(--ui-primary-color);

                > a {
                    font-size: 16px;
                    width: 100%;
                    color: #000;
                    padding: 5px 14px;
                    display: inline-block;
                    cursor: pointer;
                    user-select: none;

                    &.active {
                        background-color: var(--ui-primary-color);
                        color: var(--ui-secondary-color);
                    }

                    span {
                        text-shadow: none;
                    }

                    .giphy-box {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        padding-top: 1px;

                        span {
                            font-family: Helvetica Neue;
                            font-weight: bold;
                            margin-left: 0.2rem;
                        }
                    }
                }
            }

            #grid-giphy-parent {
                overflow: hidden auto;
                height: 100%; //375px
                margin-top: 16px;
                position: relative;

                #giphy-logo {
                    cursor: pointer;
                    position: fixed;
                    bottom: 1rem;
                    left: 1rem;
                    height: 42px;
                    opacity: 0;
                    transition: opacity 0.5s;
                    z-index: 1;
                }

                .bg-search-giphy {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 100%;
                    height: 100%;
                    padding: 16px;
                    background-color: rgba(220, 53, 69, 0.1);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    transition: visibility 0.5s;

                    h2 {
                        display: block;
                        width: 100%;
                        margin-bottom: 24px !important;
                        text-align: center;
                        font-size: 24px;
                        word-break: break-word;
                        z-index: 1;

                        @media screen and (max-width: 767px) {
                            font-size: 16px;
                        }
                    }

                    img {
                        max-width: 300px;
                        width: 100%;
                        height: auto;
                        display: block;
                        margin: auto;
                    }

                    #not-found-search-giphy {
                        display: none;
                    }
                }
            }
        }
    }
    .hidden {
        display: none;
    }

    .max-w-xs {
        max-width: 20rem;
    }
}

.theme-dark-mode .upload-image-modal .modal-content .modal-body .btn-group > a {
    color: #fff;
}
</style>
